<template>
	<div class="main situation" v-loading="loading">
		<div class="crumb" v-if="crumbList && crumbList.length">
			<span v-for="(item,index) in crumbList" class="crumb_item" :key="index" @click="closeMask"><a href="javascript:;">{{item}}</a></span>
			<span class="order_list" style="display: flex;">
				<span class="crumb_item bg_eee" :class="{activeCrumb: item.recordNo == baseInfo.recordNo}" v-for="(item,index) in myAccidentList" :key="('accidentList_'+index)" @click="reStartMask(item.id)">
					{{item.recordNo}}
					<img src="../../assets/images/icon/home_tab_icon_close.png" alt="" class="close_img" @click.stop="doCancel(item.id,index)">
				</span>
			</span>
			<span class="jumpBtn">
				<div class="myJumpBtn" @click="setScrollTop(0)">基本信息</div>
				<div class="myJumpBtn" @click="setScrollTop(1)">证据照片</div>
				<div class="myJumpBtn" @click="setScrollTop(2)">人员信息</div>
				<div class="myJumpBtn" @click="setScrollTop(3)">车辆信息</div>
				<div class="myJumpBtn" @click="setScrollTop(4)">违法信息</div>
				<div class="myJumpBtn" @click="setScrollTop(5)">询问笔记</div>
				<div class="myJumpBtn" @click="setScrollTop(6)">返回凭证</div>
			</span>
		</div>
		<div style="height: 100%;">
			<div class="leftContent input_new_style" :class="[fullVideo ? 'fullVideoClass_left' : 'original_left']">
				<el-collapse v-model="activeName_a">
					<el-collapse-item title="基本信息" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>违法处理地点</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.organizationId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in daduiLists" :key="`${item.id}_xwdd`" :label="item.fullName" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>违法处理单位</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.handleOrganizationId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in daduiLists" :key="`${item.id}_gzdw`" :label="item.fullName" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>经办人1</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.firstOperatorId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in userLists" :key="`${item.id}_xwr1`" :label="item.realname" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>经办人2</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.secondOperatorId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in userLists" :key="`${item.id}_xwr2`" :label="item.realname" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>违法处理时间</div>
										</div>
										<div class="right h32">
											<el-date-picker v-model="baseInfo.handleTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="disabled_edit" placeholder="选择日期"></el-date-picker>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>预约地点</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="baseInfo.location" :disabled="disabled_edit"></el-input>
											<span class="case_address" v-if="!disabled_edit" @click="showMap(1)">
												<i class="icon_address"></i>
											</span>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>违法时间</div>
										</div>
										<div class="right h32">
											<el-date-picker v-model="baseInfo.accidentTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="disabled_edit" placeholder="选择日期"></el-date-picker>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>违法地点</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="baseInfo.accidentAddress" :disabled="disabled_edit"></el-input>
											<!-- <span class="case_address" v-if="!disabled_edit" @click="showMap(4)">
												<i class="icon_address"></i>
											</span> -->
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>道路代码</div>
										</div>
										<div class="right h32">
											<el-autocomplete style="width: 48%; margin-right: 2%;" placeholder="请输入" v-model="baseInfo.firstRoadInfo" :disabled="disabled_edit" :fetch-suggestions="((e, cb) => {getRoadCode(e, cb, 1)})" @select="handleSelect($event, 1)"></el-autocomplete>
											<el-autocomplete style="width: 50%;" placeholder="请输入" v-model="baseInfo.secondRoadInfo" :disabled="disabled_edit" :fetch-suggestions="((e, cb) => {getRoadCode(e, cb, 2)})" @select="handleSelect($event, 2)"></el-autocomplete>
										</div>
									</div>
								</div>
								<!-- <div class="row">
									<div class="column">
										<div class="left">
											<div>案件类型</div>
										</div>
										<div class="right h32">一般</div>
									</div>
								</div> -->
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>违法代码</div>
										</div>
										<div class="right h32">
											<el-autocomplete placeholder="请输入" v-model="autocomplete_value" :disabled="disabled_edit" :fetch-suggestions="((e, cb) => {getRoadCode(e, cb, 3)})" @select="handleSelect($event, 3)"></el-autocomplete>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>案件类型</div>
										</div>
										<div class="right h32">一般程序</div>
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeName_g">
					<el-collapse-item title="证据照片" name="1">
						<div class="retrun_case">
							<template v-for="(item, index) in evidences">
								<img class="retrun_image" :key="index" v-if="item.indexOf('.mp4') == -1" :src="getImageUrl(item) + '&time=' + new Date().getTime()" @click="previewImg(item)" >
								<img class="retrun_image" :key="index" v-else src="../../assets/images/pics/player.png" @click="previewImg(item)" />
							</template>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeName_b">
					<el-collapse-item title="人员信息" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>姓名</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.realName" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>性别</div>
										</div>
										<div class="right h32">
                                            <el-select placeholder="请选择" v-model="userInfos.sex" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in sexTypeLists" :key="`${item.id}_xb`" :label="item.label" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>联系方式</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.phone" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>驾驶证/身份证号</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.idCardNo" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>现住详细地址</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.address" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>准驾车型</div>
										</div>
										<div class="right h32">
											<!-- <el-select placeholder="请选择" v-model="userInfos.carClassId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.driList" :key="item.CODE" :label="item.CODE" :value="item.id"></el-option>
											</el-select> -->
											<el-select placeholder="请选择" v-model="moreCarClass" :disabled="disabled_edit" multiple filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.driList" :key="item.CODE" :label="item.CODE" :value="`${item.id}`"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>驾驶证档案编号</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.archivesCode" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>发证机构</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.issuingAuthority" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>证件地址</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.cardAddress" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>工作单位</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.workCompany" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>法定代表人</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.legalLeader" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>出生日期</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.birthday" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>文化程度</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.educationLevel" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.knowledgeLists" :key="item.id" :label="item.name" :value="item.name"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>职业</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfos.job" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>政治面貌</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.politicalOutlook" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.politicalLists" :key="item.id" :label="item.name" :value="item.name"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>交通方式</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.transportWay" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.meaList" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeName_h">
					<el-collapse-item title="车辆信息" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>车牌号码</div>
										</div>
										<div class="right h32">
											<el-select style="width: 120px; margin-right: 10px;" placeholder="请选择" v-model="car_title" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="(item, index) in tempList.liceList" :key="index" :label="item.name" :value="item.name"></el-option>
											</el-select>
											<el-input placeholder="请输入" v-model="car_number" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>号牌种类</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.plateTypeId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.flaList" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>车辆类型</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfos.vehicleTypeId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in tempList.vehList" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row"></div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeName_i">
					<el-collapse-item title="违法信息" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>文书编号</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="note.fileNo" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>罚款金额</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" type="number" v-model="userInfos.price" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>通知书文书编号</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="note.notificationProcessBookNo" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row"></div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeName_c">
					<el-collapse-item title="询问笔记" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>询问次数</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" type="number" v-model="note.askTimes" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>模版类型</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="note.templateName" :disabled="disabled_edit" filterable @change="selectTemplate">
												<el-option v-for="item in templateArr" :key="item.id" :label="item.name" :value="item.name"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>传唤时间</div>
										</div>
										<div class="right h32">
											<el-date-picker v-model="note.callingTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="disabled_edit" placeholder="选择日期"></el-date-picker>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>结束时间</div>
										</div>
										<div class="right h32">
											<el-date-picker v-model="note.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="disabled_edit" placeholder="选择日期"></el-date-picker>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>出发地</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="note.startAddress" :disabled="disabled_edit"></el-input>
											<span class="case_address" v-if="!disabled_edit" @click="showMap(2)">
												<i class="icon_address"></i>
											</span>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div><i class="required">*</i>目的地</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="note.endAddress" :disabled="disabled_edit"></el-input>
											<span class="case_address" v-if="!disabled_edit" @click="showMap(3)">
												<i class="icon_address"></i>
											</span>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="note_btn" v-if="!disabled_edit">
								<el-button type="primary" size="small" icon="el-icon-tickets" @click="onImportNotes">导入笔记</el-button>
							</div> -->
							<div class="big_case" v-for="(item, index) in transcripts" :key="`${index}_xwbj`">
								<template v-if="item.operateType != 'REMOVE'">
									<ul class="ul_case">
										<li>
											<span>问：</span><el-input class="my_input" placeholder="请输入" type="textarea" :rows="3" v-model="item.question" :disabled="disabled_edit" @change="onChengeQ(index)"></el-input>
										</li>
										<li>
											<span>答：</span><el-input placeholder="请输入" type="textarea" :rows="2" v-model="item.answer" :disabled="disabled_edit" @change="onChengeQ(index)"></el-input>
										</li>
										<!-- <li v-if="item.answerType == 'label'">
											<span>答：</span><el-input placeholder="请输入" type="textarea" :rows="1" v-model="item.answer" :disabled="disabled_edit" @change="onChengeQ(index)"></el-input>
										</li>
										<li v-else-if="item.answerType == 'select'">
											<span>答：</span>
											<el-select style="width: 100%" placeholder="请选择" v-model="item.answer" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="an in JSON.parse(item.oriAnswer)" :key="`${an}_hbt`" :label="an" :value="an"></el-option>
											</el-select>
										</li> -->
									</ul>
									<ul class="ul_contor" v-if="!disabled_edit">
										<li>
											<i class="el-icon-refresh" @click="onCutQ(index)"></i>
										</li>
										<li>
											<i class="el-icon-plus" @click="onAddQ(index)"></i>
										</li>
										<li>
											<i class="el-icon-delete" @click="onDeletaQ(index, item)"></i>
										</li>
									</ul>
								</template>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeName_f">
					<el-collapse-item title="返回凭证" name="1">
						<div class="retrun_case">
							<!-- 公安行政案件权利义务告知书 -->
							<template v-if="notificationImage">
								<img class="retrun_image" :src="getImageUrl(notificationImage) + '&time=' + new Date().getTime()" @click="previewImg(notificationImage, 'type2')">
							</template>
							<!-- 公安交通管理行政处罚告知笔录 -->
							<template v-if="notificationRecordImage">
								<img class="retrun_image" :src="getImageUrl(notificationRecordImage) + '&time=' + new Date().getTime()" @click="previewImg(notificationRecordImage, 'type2')">
							</template>
							<!-- 非现场处罚承诺书 -->
							<template v-if="commitImage">
								<img class="retrun_image" :src="getImageUrl(commitImage) + '&time=' + new Date().getTime()" @click="previewImg(commitImage, 'type2')">
							</template>
							<!-- 询问笔录 -->
							<template v-if="askRecordImage">
								<!-- <img class="retrun_image" :src="getImageUrl(askRecordImage) + '&time=' + new Date().getTime()" @click="previewImg(askRecordImage, 'type2')"> -->
								<img class="retrun_image" v-for="(item, index) in askRecordImage.split(',')" :key="index" :src="getImageUrl(item) + '&time=' + new Date().getTime()" @click="previewImg(item, 'type2')">
							</template>
							<!-- 通知书 -->
							<template v-if="notificationProcessImage">
								<img class="retrun_image" :src="getImageUrl(notificationProcessImage) + '&time=' + new Date().getTime()" @click="previewImg(notificationProcessImage, 'type2')">
							</template>
							<!-- 处罚文书 -->
							<template v-if="normalPenaltiesImage">
								<img class="retrun_image" style="background:#f8f8f8;" :src="getImageUrl(normalPenaltiesImage) + '&time=' + new Date().getTime()" @click="previewImg(normalPenaltiesImage, 'type2')">
							</template>
							<!-- 首违文书 -->
							<template v-if="firstWenshuImage">
								<img class="retrun_image" :src="getImageUrl(firstWenshuImage) + '&time=' + new Date().getTime()" @click="previewImg(firstWenshuImage, 'type2')">
							</template>
						</div>
					</el-collapse-item>
				</el-collapse>
				<div style="width: 100%; height: 66px;"></div>
				<div style="display:none;">
					<template v-if="normalPenaltiesImage">
						<div ref="print">
							<img style="width:100%; height:auto;" :src="getImageUrl(normalPenaltiesImage) + '&time=' + new Date().getTime()">
						</div>
					</template>
				</div>
			</div>

			<div class="rightContent" :class="{ fullVideoClass_right: fullVideo }">
				<div class="left no_video_text" v-if="trtcStatus">
					<span v-if="!disabled_edit">
						<el-button style="width:200px;" type="success" v-if="remoteStatus == 'success' && !hasLocal">用户在线</el-button>
						<el-button style="width:200px;" type="danger" v-if="remoteStatus == 'danger' && !list.length">用户离线</el-button>
					</span>
				</div>
				<div class="left" v-else>
					<div v-if="videoBtnShow" class="videoBtnZone">
						<span id="myBtnCase2" v-if="!disabled_edit">
							<el-button type="success" v-if="remoteStatus == 'success' && !hasLocal" v-preventReClick="5000" @click="getRoom">视频呼叫</el-button>
							<el-button type="danger" v-if="remoteStatus == 'danger' && !list.length" v-preventReClick="5000" @click="notInRoom">视频呼叫</el-button>
						</span>
					</div>
					<span v-show="videoState == 0" class="display-flex-between—new" style="margin-top: 478px;">
						<div id="warp myLocal" class="userlist local" :class="[myTempIndex === null ? myMainVideo : '']" v-if="localStream" @click="switchLocalMain1($event)">
							<div id='local_stream'>
								<div class="role1" v-if="list.length" @click.stop="muteLocalAudio">
									<img class="policeMuteClass" :src="isAudio ? require('../../assets/images/pics/icon_microphone2_sel.png') : require('../../assets/images/pics/icon_microphone2_nor.png')">
									<span>交警</span>
								</div>
								<!-- <div class="role2" v-if="list.length">
                                    <img src="../../assets/images/pics/icon_video_open.png" class="myIcon" v-if="list.length > 0 && !isShow" @click.stop="onChangeView" />
                                    <img src="../../assets/images/pics/icon_video_close.png" class="myIcon" v-if="list.length > 0 && isShow" @click.stop="onChangeView" />
                                </div> -->
							</div>
							<div id='mask' class="maskable" v-show="!isVedio"></div>
						</div>
						<div id="warp" class="userlist bg-white remote police" v-if="list.length && showPolice">
							交警
						</div>
						<div class="userlist remoteClass remote user" v-for="(item,index) in list" :key="item.id" :class="[myTempIndex === index ? myMainVideo : '']">
							<div :id="item.id" class="distant-stream" v-html="item.remoteStream" v-if="item.remoteStream"></div>
						</div>
					</span>
					<div class="display-flex margin-top-15">
						<div class="myBtn" v-if="!videoBtnShow" @click="leaveRoom">
							<img src="../../assets/images/pics/icon_hang_up.png" alt="">
							<div>挂断</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bottomBtns">
			<el-button type="primary" icon="el-icon-tickets" v-if="!disabled_edit" @click="onImportNotes">导入笔记</el-button>
			<el-button type="primary" v-if="disabled_edit" @click="downloadProcessFile">一键打包下载</el-button>
			<el-button type="primary" v-if="disabled_edit" @click="seeProcessFile">查看过程文件</el-button>
			<el-button type="primary" v-if="disabled_edit" @click="seeSignBook">查看文书</el-button>
			<el-button type="primary" v-if="disabled_edit" @click="showVideos">查看视频</el-button>
			<el-button type="primary" v-if="!disabled_edit" @click="sendProcessFile">推送过程文件</el-button>
			<el-button type="primary" v-if="!disabled_edit" @click="sendSignBook">推送文书</el-button>
			<el-button type="primary" v-if="!disabled_edit" @click="printSignBook">打印文书</el-button>
			<el-button type="danger" v-if="!disabled_edit" @click="stopHandle">处置终止</el-button>
			<el-button type="success" v-if="!disabled_edit" @click="onFinish">全流程完成</el-button>
			<el-button plain @click="closeMask">返回</el-button>
			<el-button style="margin-left:100px" type="primary" plain v-if="!disabled_edit" @click="onSendImages">重发三证短信</el-button>
			<el-button type="primary" plain v-if="!disabled_edit" @click="onSendMessage">重发用户短信</el-button>
			<el-button type="danger" v-if="!disabled_edit" @click="onFirstWS">首违文书推送</el-button>
		</div>

		<el-dialog width="80%" title="询问笔记问题" center :visible.sync="dialog_state" :close-on-click-modal="false" :append-to-body="true">
			<div class="big_case" v-for="(item, index) in questions" :key="`${index}_xwbj`">
				<ul class="ul_case">
					<li>
						<span>问：</span><el-input class="my_input" disabled placeholder="请输入" type="textarea" :rows="2" v-model="item.question"></el-input>
					</li>
					<li>
						<span>答：</span><el-input disabled placeholder="请输入" type="textarea" :rows="1" v-model="item.answer"></el-input>
					</li>
					<!-- <li v-else-if="item.answerType == 'select'">
                        <span>答：</span>
                        <el-select style="width: 100%" disabled placeholder="请选择" v-model="item.answer" filterable @change="$forceUpdate()">
                            <el-option v-for="an in JSON.parse(item.oriAnswer)" :key="`${an}_hbt`" :label="an" :value="an"></el-option>
                        </el-select>
                    </li> -->
				</ul>
				<ul class="ul_contor">
					<li class="ul_li_btn" @click="onSelectQ(index, item)">选择</li>
				</ul>
			</div>
		</el-dialog>

		<transition name="el-zoom-in-center">
			<MapMask v-if="map_state" :lng="lng" :lat="lat" :mapIndex="mapIndex" @hideMap="hideMap"></MapMask>
		</transition>
		<transition name="el-zoom-in-center">
			<Videos v-if="videos_state" :videosId="roomId" @hideVideos="hideVideos"></Videos>
		</transition>
	</div>
</template>

<script>
	import LibGenerateTestUserSig from "../../../static/js/lib-generate-test-usersig.min.js"
	import $ from "../../../static/js/jquery-3.2.1.min.js"
	import TRTC from "trtc-js-sdk"
	import axios from "axios"
	import config from "@/common/env.js"
	import { mapState } from "vuex"
	import dwt from "./components/dwt"
	import MapMask from "./components/map.vue"
	import Videos from "./components/videos"
	import tempList from "./json/index.js"

	export default {
		props: ["roomId"],
		name: "videoPlat",
		components: {
			dwt,
			MapMask,
			Videos,
		},
		data() {
			return {
				// ---------- new data ----------
				loading: false,
				disabled_edit: false,
				activeName_a: ["1"],
				activeName_b: ["1"],
				activeName_c: ["1"],
				activeName_e: ["1"],
				activeName_f: ["1"],
				activeName_g: ["1"],
				activeName_h: ["1"],
				activeName_i: ["1"],
				daduiLists: [],
				userLists: [],
				
				baseInfo: {},
				userInfos: {},
				evidences: [],
				note: {},
				transcripts: [],
				questions: [],
				dialog_state: false,
				s_index: null,
				s_type: null,
				templateArr: [],
				moreCarClass: [],

				notificationImage: null,//公安行政案件权利义务告知书
				notificationRecordImage: null,//公安交通管理行政处罚告知笔录
				commitImage: null,//非现场处罚承诺书
				askRecordImage: null,//询问笔录
				normalPenaltiesImage: null, //处罚文书
				notificationProcessImage: null,
				firstWenshuImage: null, //首违文书
				signErrorLists: [],

				car_title: config.configuration.carRegion,
				car_number: null,
				textLists: [],
				autocomplete_value: null,

				map_state: false,
				lng: 116.3974803686142,
				lat: 39.90879187918217,
				mapIndex: null,

				videos_state: false,

				sexTypeLists: [
                    {id: "1", label: "男"},
					{id: "0", label: "女"},
				],

				// -------------------- old data --------------------

				// ***** 音视频data start *****
				myTempIndex: 0,
				remoteUserStatus: false,
				muteMeObj: {},
				margin0: "margin0",
				tempKey: {},
				showPolice: true,
				hasLocal: false,
				fullVideo: false,
				list: [], // 远端流列表
				client: "", // 客户端服务
				remoteStream: "", // 远方播放流
				localStream: "", // 本地流,
				isVedio: true, // 当前是否打开摄像头
				isAudio: true, // 当前是否打开麦克风
				members_: new Map(), // 成员
				isHave: false, //当前列表是否有该成员
				stream: null,
				newStream: null,
				videoBtnShow: true,

				myMainVideo: "myMainVideo",
				userId: "",
				// ***** 音视频data end *****
				trtcStatus: false,
				noSave: false,
				id: null,
				usePart: null,
				nowId: "",
				userItemInterval: null,
				videoState: 0, //-1代表默认;0代表微信;1代表支付宝
				isShowView: false,
				disabled_btn: false,
				tempList: tempList,

			}
		},
		watch: {
			myTempIndex(newVal, oldVal) {
				console.log(newVal)
				if (newVal == 0 || newVal) {
					if (this.list.length == 1) {
						let local = document.getElementById('local_stream');
						local.classList.add('margin0');
					} else {
						$("#local_stream").removeClass('margin0');
					}
				}
			},

		},
		computed: {
			...mapState(['command', 'myAccidentList']),

			crumbList() {
				return this.$route.meta.crumbList;
			},
			isShow() {
				let isShowView = this.isShowView || sessionStorage.getItem('isShowView');
				if (isShowView == 'true' || isShowView == true) {
					return true;
				} else if (isShowView == 'false' || isShowView == false) {
					return false;
				} else {
					return false;
				}
			},
			remoteStatus() {
				return this.remoteUserStatus ? "success" : "danger";
			},

		},
		beforeMount() {
			var beginTime = 0; //执行onbeforeunload的开始时间
			var differTime = 0; //时间差
			let that = this;
			window.onunload = function() {
				differTime = new Date().getTime() - beginTime;
				if (differTime <= 5) {
					console.log("浏览器关闭")
					that.saveTemp();
				} else {
					console.log("浏览器刷新")
					// that.saveTemp();
				}
			}
			window.onbeforeunload = function() {
				beginTime = new Date().getTime();
			}

		},
		created() {
			// this.getDaduiLists();
			this.getUserLists();
			this.getTemplateLists();
		},
		mounted() {
			window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))

			let _this = this;
			window.muteMyVideo = this.muteMyVideo;
			window.muteMyAudio = this.muteMyAudio;
			window.stopMyVideo = this.stopMyVideo
			window.snapMyVideo = this.snapMyVideo;
			window.kickPerson = this.kickPerson;
			window.goTop = this.goTop;

			this.myLoopMethod();
			clearInterval(this.userItemInterval);
			this.userItemInterval = setInterval(() => {
				_this.myLoopMethod();
			}, 4000)

			this.getNewDetail();
		},
		beforeDestroy() {
			console.log("卸载")
			if (!this.noSave) {
				this.saveTemp();
			}
			window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))

			this.leaveRoom();
			clearInterval(this.userItemInterval);
		},
		methods: {
			// ---------- new methods ----------
			// 获取大队列表
			getDaduiLists() {
				this.$axios.get(`/admin/organization/childrenList/parent-${this.baseInfo.organizationParentId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.daduiLists = data;
					}
				})
			},
			// 询问人 and 记录人
			getUserLists() {
				let id = JSON.parse(localStorage.getItem("userinfos")).organizationId || null;
				this.$axios.get(`/admin/organization/users/${id}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.userLists = data;
					}
				})
			},

			// 道路代码 and 违法代码
			getRoadCode(e, cb, n) {
				// console.log(e)
				// console.log(n)
				if(n == 1) {
					this.$axios.post(`/admin/appointment/${1}/roadList`, {
						level: 1,
						name: e,
						parentCode: null,
					}).then((res) => {
						let data = this.AppUtils.checkResponse(res);
						if (data.code == 0) {
							this.textLists = data.data;
							this.textLists.map(item => {
								item.value = item.roadName;
							})
							cb(this.textLists);
							this.$forceUpdate();
						}
					})
				} else if(n == 2) {
					this.$axios.post(`/admin/appointment/${2}/roadList`, {
						level: 2,
						name: e,
						parentCode: this.baseInfo.firstRoadCode,
					}).then((res) => {
						let data = this.AppUtils.checkResponse(res);
						if (data.code == 0) {
							this.textLists = data.data;
							this.textLists.map(item => {
								item.value = item.roadName;
							})
							cb(this.textLists);
							this.$forceUpdate();
						}
					})
				} else if(n == 3) {
					this.$axios.post(`/admin/appointment/illegalList`, {
						name: e
					}).then((res) => {
						let data = this.AppUtils.checkResponse(res);
						if (data.code == 0) {
							this.textLists = data.data;
							this.textLists.map(item => {
								item.value = item.illegalInfo;
							})
							cb(this.textLists);
							this.$forceUpdate();
						}
					})
				}
			},
			handleSelect(e, n) {
				// console.log(e)
				// console.log(n)
				if(n == 1) {
					this.baseInfo.firstRoadInfo = e.value;
					this.baseInfo.firstRoadId = e.id;
					this.baseInfo.firstRoadCode = e.roadCode;
					this.baseInfo.secondRoadInfo = null;
					this.baseInfo.secondRoadId = null;
					this.baseInfo.secondRoadCode = null;
				} else if(n == 2) {
					this.baseInfo.secondRoadInfo = e.value;
					this.baseInfo.secondRoadId = e.id;
					this.baseInfo.secondRoadCode = e.roadCode;
				} else if(n == 3) {
					this.baseInfo.illegalInfo = {
						illegalInfo: e.value,
						illegalCodeId: e.id,
						illegalCode: e.illegalCode,
						firstClause: e.firstClause,
						secondClause: e.secondClause,
					}
				}
				if(n != 3) {
					this.concatAddress();
				}
			},

			// 事故地址拼接
			concatAddress() {
				this.baseInfo.accidentAddress = `${this.baseInfo.firstRoadInfo}${this.baseInfo.secondRoadInfo == null ? "" : this.baseInfo.secondRoadInfo}`;
			},

			// 地图显示
			showMap(n) {
				this.map_state = true;
				this.mapIndex = n;
			},
			hideMap(val) {
				console.log(val)
				this.map_state = false;
				if(val.index == 2) {
					this.note.startAddress = val.addressStr;
				} else if(val.index == 3) {
					this.note.endAddress = val.addressStr;
				}
			},

			// 详情
			getNewDetail() {
				this.$axios.get(`/admin/appointment/normal/detail/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.userId = data.baseInfo.videoUserId;
						this.trtcStatus = data.trtcStatus == 1 ? false : true;
						if(data.baseInfo.status >= 3 && data.baseInfo.status != 7) {
							this.disabled_edit = true;
							clearInterval(this.userItemInterval);
						} else {
							this.disabled_edit = false;
						}
						this.baseInfo = Object.assign({}, this.baseInfo, data.baseInfo);
						this.getDaduiLists();
						this.autocomplete_value = data.baseInfo.illegalInfo == null ? null : data.baseInfo.illegalInfo.illegalInfo;
						this.lng = data.baseInfo.lng;
						this.lat = data.baseInfo.lat;
						this.userInfos = Object.assign({}, this.userInfos, data.userInfos[0], {
							birthday: data.userInfos[0].birthday ? data.userInfos[0].birthday.replace(/\//g, "-") : "",
							sex: data.userInfos[0].sex != null ? data.userInfos[0].sex.toString() : null
						});
						if(this.userInfos.carClassIds) {
							let str = this.userInfos.carClassIds;
							this.moreCarClass = str.split(",");
						}

						let plateNo = data.userInfos[0].carPlate || "";
						let plateFirst = data.baseInfo.transportWay == 3 ? "" : plateNo.substring(0, 1) || config.configuration.carRegion;
						let plateSecond = plateNo.substring(1) || "";
						this.car_title = plateFirst;
						this.car_number = plateSecond;

						this.evidences = Object.assign([], this.evidences, data.evidences);
						this.note = Object.assign({}, this.note, data.note);
						this.transcripts = Object.assign([], this.transcripts, data.note && data.note.savedItems.length > 0 ? data.note.savedItems : []);
						this.questions = Object.assign([], this.questions, data.note && data.note.savedItems.length > 0 ? data.note.savedItems : []);

						this.notificationImage = data.note.notificationImage || null; //公安行政案件权利义务告知书
						this.notificationRecordImage = data.note.notificationRecordImage || null; //公安交通管理行政处罚告知笔录
						this.commitImage = data.note.commitImage || null; //非现场处罚承诺书
						this.askRecordImage = data.note.askRecordImage || null; //询问笔录
						this.normalPenaltiesImage = data.note.normalPenaltiesImage || null; //处罚文书
						this.notificationProcessImage = data.note.notificationProcessImage || null;
						this.firstWenshuImage = data.note.normalFirstWFImage || null;
					}
				})
			},

			// 获取模版类型列表
			getTemplateLists() {
				this.$axios.get(`/admin/appointment/templateList`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.templateArr = data;
					}
				})
			},

			// 切换模版类型
			selectTemplate(e) {

			},

			// 导入笔记
			onImportNotes() {
				if(this.transcripts.length == 0) return this.saveTemp(1);
				this.$confirm(`将覆盖当前已有笔录，导入之后无法恢复， 是否继续？`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(() => {
					this.saveTemp(1);
				}).catch(() => {
					
				})
			},
			// 获取导入笔记
			saveNotes() {
				this.$axios.get(`/admin/appointment/import/note/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.transcripts = data;
					}
				})
			},

			// 一键打包下载
			downloadProcessFile() {
				let _this = this;
				this.loading = true;
                this.$axios.get(`/admin/appointment/downloadZip/${this.roomId}`, { responseType: "blob" }).then(res => {
                    console.log(res.data)
					this.loading = false;
					if(res.data && res.data.type == "application/json") {
						const fileReader = new FileReader();
						fileReader.readAsText(res.data, "utf-8");
						fileReader.onload = function() {
							const data = fileReader.result;
							const { msg } = JSON.parse(data);
							console.log(data)
							_this.$message.error(msg);
						}
					} else {
						let fileName = "过程文件包.zip";
						let blob = new Blob([res.data], { type: "application/zip" });
						if(window.navigator.msSaveOrOpenBlob) {
							navigator.msSaveBlob(blob, fileName);
						} else {
							let link = document.createElement("a");
							link.href = window.URL.createObjectURL(blob);
							link.download = fileName;
							link.click();
							window.URL.revokeObjectURL(link.href);
						}
					}
                }).catch(err => {
                    this.loading = false;
                })
			},

			// 查看过程文件
			seeProcessFile() {
				this.previewImg("", "type2");
			},

			// 查看视频
			showVideos() {
				this.videos_state = true;
			},
			hideVideos() {
				this.videos_state = false;
			},

			// 生成文书
			sendAjax(fileTypeDesc) {
				let _this = this;
				let recordId = this.roomId;
				this.signErrorLists = [];
				if(this.transcripts.length < 1) {
					return this.$message.error("请先导入询问笔记");
				}
				// return
				// this.loading = true;
				this.$axios.get(`/admin/appointment/generate/${recordId}/${fileTypeDesc}`).then(resf => {
					// this.loading = false;
					let dataf = _this.AppUtils.checkResponse(resf);
					let { code, data, msg } = dataf;
					if(code == 0) {
						if(data.notificationImage != null) {
							this.notificationImage = data.notificationImage; //公安行政案件权利义务告知书
						}
						if(data.notificationRecordImage != null) {
							this.notificationRecordImage = data.notificationRecordImage; //公安交通管理行政处罚告知笔录
						}
						if(data.commitImage != null) {
							this.commitImage = data.commitImage; //非现场处罚承诺书
						}
						if(data.askRecordImage != null) {
							this.askRecordImage = data.askRecordImage; //询问笔录
						}
						if(data.normalPenaltiesImage != null) {
							this.normalPenaltiesImage = data.normalPenaltiesImage; //处罚文书
						}
						if(data.notificationProcessImage) {
							this.notificationProcessImage = data.notificationProcessImage;
						}

						_this.$axios.post(`/admin/appointment/pushSign/${recordId}/${fileTypeDesc}`, {
							recordId,
							fileTypeDesc
						}).then(res => {
							let datas = _this.AppUtils.checkResponse(res);
							let { code, data, msg } = datas;
							if (code == 0) {
								if(fileTypeDesc == "process") {
									_this.$message.success("推送过程文件成功");
								} else if(fileTypeDesc == "normal_clerical") {
									_this.$message.success("推送文书成功");
								}
							} else {
								_this.$message.error(msg);
							}
						})
					} else {
						this.$message.error(msg);
					}
				}).catch(err => {
					// this.loading = false;
				})
			},

			// 推送过程文件
			sendProcessFile() {
				let fileTypeDesc = "process";
				// this.sendAjax(fileTypeDesc);
				this.saveTemp(fileTypeDesc);
			},

			// 推送文书
			sendSignBook() {
				let fileTypeDesc = "normal_clerical";
				// this.sendAjax(fileTypeDesc);
				this.saveTemp(fileTypeDesc);
			},

			// 查看文书
			seeSignBook() {
				this.previewImg(this.normalPenaltiesImage, "type3");
			},

			// 打印文书
			printSignBook() {
				if(this.normalPenaltiesImage == null) return this.$message.error("文书未签字！");
				let options = { style: "no" }
				this.$print(this.$refs.print, options);
			},

			// 处置终止
			stopHandle() {
				this.$confirm('确定处置终止, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.get(`/admin/appointment/stop/${this.roomId}`).then(res => {
						let datas = this.AppUtils.checkResponse(res);
						let { code, data, msg } = datas;
						if (code == 0) {
							this.noSave = true;
							this.$message.success("处置终止成功");
							this.getStartMethods();
						} else {
							this.$message.error(msg);
						}
					})
				}).catch(() => {

				})
			},

			// 全流程完成
			onFinish() {
				this.$confirm('确定全流程处置完成？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					this.$axios.get(`/admin/appointment/finish/${this.roomId}`).then(res => {
						let datas = this.AppUtils.checkResponse(res);
						let { code, data, msg } = datas;
						if (code == 0) {
							this.noSave = true;
							this.$message.success("全流程完成成功");
							this.getStartMethods();
						} else {
							this.$message.error(msg);
						}
					})
				}).catch(() => {

				})
			},

			// 重发三证短信
			onSendImages() {
				this.$axios.get(`/admin/appointment/push/threeCard/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						this.$message.success("发送成功");
					} else {
						this.$message.error(msg);
					}
				})
			},

			// 重发用户短信
			onSendMessage() {
				this.$axios.get(`/admin/appointment/reinvite/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						this.$message.success("发送成功");
					} else {
						this.$message.error(msg);
					}
				})
			},

			// 首违文书推送
			onFirstWS() {
				this.saveTemp("first_ws");
			},
			sendFirstWS() {
				this.$axios.get(`/admin/appointment/generateFirstWf/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						this.$message.success("推送首违文书成功");
						if(data.normalFirstWFImage != null) {
							this.firstWenshuImage = data.normalFirstWFImage;
						}
					} else {
						this.$message.error(msg);
					}
				})
			},

			// 笔录相关操作
			onCutQ(index) {
				this.dialog_state = true;
				this.s_index = index;
				this.s_type = 1;
			},
			onAddQ(index) {
				this.dialog_state = true;
				this.s_index = index;
				this.s_type = 2;
			},
			onDeletaQ(index, item) {
				console.log(index)
				console.log(item)
				console.log(this.transcripts)
				let data = this.transcripts;
				data[index].operateType = "REMOVE";
				this.transcripts = data;
				this.$forceUpdate();
			},
			onSelectQ(index, item) {
				console.log(index)
				console.log(item)
				console.log(this.s_index)
				console.log(this.s_type)
				let json = {
					answer: null, //question.answer
					answerType: null,
					operateType: "ADD",
					oriAnswer: null,
					oriQuestion: null,
					question: null, //question.question
					questionId: null,
					questionItemId: null, //questions.id
					recordId: this.roomId,
					answerType: "label",
				}
				if (this.s_type == 1) {
					let data = this.transcripts;
					data[this.s_index].operateType = "UPDATE";
					data[this.s_index].question = item.question;
					data[this.s_index].answer = item.answer;
					data[this.s_index].questionItemId = item.id;
					this.transcripts = data;
					this.$forceUpdate();
				} else if (this.s_type == 2) {
					let data = this.transcripts;
					json.answer = item.answer;
					json.question = item.question;
					json.questionItemId = item.id;
					data.splice(this.s_index + 1, 0, json);
					this.transcripts = data;
					this.$forceUpdate();
				}
				this.dialog_state = false;
			},
			onChengeQ(index) {
				console.log(index)
				let data = this.transcripts;
				data[index].operateType = data[index].questionId == null ? "ADD" : "UPDATE";
				this.transcripts = data;
				this.$forceUpdate();
			},

			getImageUrl(url, type) {
				let str = type ? "/file/server/file" : "/file/server/decrypt/file";
				return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
			},
			previewImg(url, type) {
				console.log(type)
				let data = [];
				// data = this.evidences;
				let evidences = JSON.parse(JSON.stringify(this.evidences));
				evidences.forEach(item => {
					if(item.indexOf('.mp4') == -1) data.push(item);
				})
				if(type == "type2") {
					data = [];
					if(this.notificationImage != null) {
						data.push(this.notificationImage)
					}
					if(this.notificationRecordImage != null) {
						data.push(this.notificationRecordImage)
					}
					if(this.commitImage != null) {
						data.push(this.commitImage)
					}
					if(this.askRecordImage != null) {
						// data.push(this.askRecordImage)
						data = data.concat(this.askRecordImage.split(','))
					}
					if(this.normalPenaltiesImage != null) {
						data.push(this.normalPenaltiesImage)
					}
					if(this.notificationProcessImage != null) {
						data.push(this.notificationProcessImage)
					}
					if(this.firstWenshuImage != null) {
						data.push(this.firstWenshuImage)
					}
					if(url == "") url = data[0];
					if(data.length < 1) return this.$message.error("没有可以查看的过程文件");
				}
				if(type == "type3") {
					data = [];
					if(this.normalPenaltiesImage != null) {
						data.push(this.normalPenaltiesImage)
					}
					if(data.length < 1) return this.$message.error("没有可以查看的文书");
				}

				data = Array.from(new Set(data));
				let index = data.findIndex(item => item == url);
				let that = this;
				if (this.$store.state.previewImgUrl) {
					this.$store.commit("SHOW_PREVIEW_IMG", "")
				}
				setTimeout(() => {
					if (index > -1) {
						localStorage.setItem("myIndex", index);
						localStorage.setItem("myPics", JSON.stringify(data));
					} else {
						data.push(url);
						localStorage.setItem("myIndex", data.length - 1);
						localStorage.setItem("myPics", JSON.stringify(data));
					}
					localStorage.setItem("newDe", "");
					that.$store.commit("SHOW_PREVIEW_IMG", url);
				}, 500)
			},


			// ---------- old methods ----------

			// 案情暂存
			saveTemp(arg) {
				console.log("baseInfo", this.baseInfo)
				console.log("userInfos", this.userInfos)
				console.log("note", this.note)
				console.log("transcripts", this.transcripts)
				let baseInfo = this.baseInfo;
				let userInfos = this.userInfos;
				let note = this.note;
				let transcripts = this.transcripts;
				userInfos.carClassIds = this.moreCarClass.join(",");
				let base_json = {
					accidentTime: "违法时间",
					accidentAddress: "违法地点",
					firstRoadInfo: "道路代码",
				}
				let user_json = {
					realName: "姓名",
					sex: "性别",
					phone: "联系方式",
					address: "现住详细地址",
					carClassIds: "准驾车型",
					archivesCode: "驾驶证档案编号",
					issuingAuthority: "发证机构",
					cardAddress: "证件地址",
					birthday: "出生日期",
					educationLevel: "文化程度",
					job: "职业",
					politicalOutlook: "政治面貌",
					transportWay: "交通方式",
					price: "罚款金额",
					plateTypeId: "号牌种类",
					vehicleTypeId: "车辆类型",
				}
				let book_json = {
					fileNo: "文书编号",
					notificationProcessBookNo: "通知书文书编号",
					askTimes: "询问次数",
					templateName: "模版类型",
					callingTime: "传唤时间",
					endTime: "结束时间",
					startAddress: "出发地",
					endAddress: "目的地",
				}
				if(arg == 1 || arg == "process" || arg == "normal_clerical" || arg == "first_ws") {
					for(let i in base_json) {
						if(baseInfo[i] == null || baseInfo[i] == "") {
							this.setScrollTop(0);
							return this.$message.error(`请填写 ${base_json[i]}`);
						}
					}
					if(this.autocomplete_value == null || this.autocomplete_value == "") {
						this.setScrollTop(0);
						return this.$message.error(`请填写 违法代码`);
					}
					for(let i in user_json) {
						if(userInfos[i] == null || userInfos[i] == "") {
							let n = i == "plateTypeId" || i == "vehicleTypeId" ? 3 : 2;
							if(i == "price") n = 4;
							this.setScrollTop(n);
							return this.$message.error(`请填写 ${user_json[i]}`);
						}
					}
					if((this.car_title == null || this.car_title == "") && (this.car_number == null || this.car_number == "")) {
						this.setScrollTop(3);
						return this.$message.error(`请填写 车牌号码`);
					}
					for(let i in book_json) {
						if(note[i] == null || note[i] == "") {
							let n = i == "fileNo" ? 4 : 5;
							this.setScrollTop(n);
							return this.$message.error(`请填写 ${book_json[i]}`);
						}
					}
				}
				
				// console.log("--- save success ---")
				// return
				if(this.disabled_edit) return;

				this.$axios.post(`/admin/appointment/normal/save`, {
					baseInfo,
					userInfo: [userInfos],
					note,
					transcripts,
				}).then(res => {
					// console.log(res)
					let { code, data, msg } = res.data;
					if (code == 0) {
						if (arg == 1) {
							this.saveNotes();
						} else if(arg == "process" || arg == "normal_clerical") {
							this.sendAjax(arg);
						} else if(arg == "first_ws") {
							this.sendFirstWS();
						} else {
							this.$message.success("保存成功");
						}
					} else {
						this.$message.error(msg);
					}
				})
			},

			myLoopMethod() {
				let accidentId = this.roomId;
				this.$axios.get(`/admin/appointment/record/${accidentId}/status`).then((res) => {
					let data = this.AppUtils.checkResponse(res);
					let status = data.data;
					if (res.data.code == 0) {
						this.remoteUserStatus = status.userOnline;

						if(status.notificationImage != null) {
							this.notificationImage = status.notificationImage; //公安行政案件权利义务告知书
						}
						if(status.notificationRecordImage != null) {
							this.notificationRecordImage = status.notificationRecordImage; //公安交通管理行政处罚告知笔录
						}
						if(status.commitImage != null) {
							this.commitImage = status.commitImage; //非现场处罚承诺书
						}
						if(status.askRecordImage != null) {
							this.askRecordImage = status.askRecordImage; //询问笔录
						}
						if(status.normalPenaltiesImage != null) {
							this.normalPenaltiesImage = status.normalPenaltiesImage; //处罚文书
						}
						if(status.notificationProcessImage != null) {
							this.notificationProcessImage = status.notificationProcessImage;
						}
						if(status.firstWfImage != null) {
							this.firstWenshuImage = status.firstWfImage;
						}

						if(status.signErrorMsg != "") {
							if(this.signErrorLists.indexOf(status.signErrorMsg) == -1) {
								this.$message.error(status.signErrorMsg);
								this.signErrorLists.push(status.signErrorMsg);
							}
						}
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			doCancel(id, inde) {
				let accidentList = this.$store.state.myAccidentList;
				let index = inde;
				if (index > -1) {
					if (index == 0 && accidentList.length == 1) {
						this.closeMask();
						this.$store.commit('MyAccidentList', []);
						return false;
					}
					accidentList.splice(index, 1);
					this.$store.commit('MyAccidentList', accidentList);
					let ind = index - 1;
					if (ind < 0) {
						ind = 0;
					}
					this.reStartMask(accidentList[ind].id);
				}

			},
			reStartMask(id) {
				this.$emit('reStartMask', id)
			},

			setScrollTop(type) {
				let topValue;
				let topArray = [];
				if (type == 0) {
					topValue = 0;
				} else {
					for (let i = 0; i < type; i++) {
						topArray.push(document.getElementsByClassName('el-collapse')[i].clientHeight);
					}
					topValue = topArray.reduce((pre, val) => {
						return pre += val;
					}, 0)
				}
				$('.leftContent').animate({
					scrollTop: topValue
				}, 500)
			},

			beforeunloadHandler(e) { //根据事件进行操作进行操作
				console.log(e)
				console.log('浏览器刷新')
				this.saveTemp();
			},

			switchLocalMain1(e) {
				this.myTempIndex = null;
			},

			goTop(userId, id) {
				let ind;
				let members = this.list;
				members.forEach((item, index) => {
					if (item.userId == userId) {
						ind = index;
					}
				})
				this.myTempIndex = ind
			},

			onChangeView() {
				let notDisplay = !this.isShowView;
				this.$axios.post(`/admin/accident/display/video`, {
					notDisplay: notDisplay
				}).then(res => {
					let { code, data } = res.data;
					if (code === 0) {
						let title = notDisplay ? "车主端已关闭警端视频" : "车主端已打开警端视频";
						this.$message.success(title);
						this.isShowView = !this.isShowView;
						sessionStorage.setItem('isShowView', this.isShowView)
					}
				})
			},

			getRoom() {
				var accidenId = this.roomId;
				this.$axios.post(`/admin/appointment/${accidenId}/video/room/create`).then((res) => {
					let data = res.data;
					if (data.code === 0) {
						this.myTempIndex = 0;
						this.nowId = data.data;
						this.startJoinRoom();
						this.isAudio = true;
					} else {
						this.$message.error(data.msg);
					}
				})
			},

			kickPerson(userId) {
				let ind;
				let members = this.members_;
				let values = members.values();
				values = Array.from(values);
				let keys = members.keys();
				keys = Array.from(keys);
				values.forEach((item, index) => {
					if (item.getUserId() == userId) {
						ind = index;
					}
				})
				let that = this;
				let accidentId = this.roomId;
				let roomId = this.nowId;
				this.$axios.post(`/admin/accident/${accidentId}/video/room/${roomId}/remove/${userId} `).then(res => {
					let data = res.data;
					if (data.code === 0) {} else {
						this.$message.error(data.msg)
					}
				})
			},

			getStartMethods() {
				if (this.newStream) {
					this.leaveRoom();
				}
				clearInterval(this.userItemInterval);
				this.$emit("closeMask");
				this.$emit("startMethod");
			},

			async snapRemote(key, usePart, index) {
				if (!this.remoteUserStatus) {
					this.$message.error("报警人已退出");
					return false;
				}
				if (!this.newStream) {
					this.$message.error("截图失败,请检查视频是否接通!");
					return false;
				}
				this.tempKey = {
					key,
					usePart,
					index,
				}
			},

			closeMask() {
				this.$emit("closeMask");
				this.leaveRoom();
				this.getStartMethods();
			},

			// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-* 音视频相关操作 start *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*

			notInRoom() {
				this.$message.error("预约人未在等待状态");
			},
			startJoinRoom() {
				if (!this.remoteUserStatus) {
					// return this.$message.error("报警人未在等待状态");
				}
				this.createClient(this.userId);
			},

			close() {
				this.isVedio = true;
				this.isAudio = true;
				this.isShow = false;
				this.$emit("close");
			},

			// 创建链接
			createClient(userId) {
				// 获取签名
				const config = this.genTestUserSig(userId);
				const sdkAppId = config.sdkAppId;
				const userSig = config.userSig;
				this.client = TRTC.createClient({
					mode: "rtc",
					sdkAppId,
					userId,
					userSig,
					useStringRoomId: true,//指定房间号为字符串；有roomType打开，没有roomType去掉
				});
				// 初始化后才能加入房间
				this.joinRoom();
			},
			// 加入房间
			async joinRoom() {
				console.log("this.nowId", this.nowId);
				await this.client
					.join({
						// roomId: Number(this.nowId),//没有roomType
						roomId: config.roomType + Number(this.nowId),//有roomType
					})
					.then(() => {
						// 创建本地流
						this.createStream();
						// 播放远端流
						this.playStream();
					})
					.catch((error) => {
						console.error("进房失败 " + error);
					})

				// 注册远程监听，要放在加入房间前--这里用了发布订阅模式
				this.subscribeStream();
			},
			// 创建本地音视频流
			createStream() {
				var _this = this;
				this.localStream = TRTC.createStream({
					userId: this.userId,
					audio: true,
					video: true,
				})
				this.localStream.setVideoProfile({
					width: 640,
					height: 640,
					frameRate: 24,
					bitrate: 600, /* kpbs */
				})
				this.localStream
					.initialize()
					.then(() => {
						console.log("初始化本地流成功")
						// 创建好后才能播放 本地流播放 local_stream 是div的id
						this.localStream.play("local_stream");
						this.$nextTick(() => {
							// 创建好后才能发布
							this.publishStream();
						});
						this.hasLocal = true;
						this.updateStream();
					})
					.catch((error) => {
						_this.AppUtils.alert("初始化本地流失败 " + error);
						_this.hasLocal = false;
						var accidentId = _this.roomId;
						var roomId = _this.nowId;
						_this.$axios.post(`/admin/accident/${accidentId}/video/room/dismiss/${roomId}`).then((res) => {
							let data = res.data;
							if (data.code === 0) {} else {
								_this.$message.error(data.msg);
							}
						})
					})
			},
			// 发布本地音视频流
			publishStream() {
				var _this = this;
				this.client
					.publish(this.localStream)
					.catch((error) => {
						_this.AppUtils.alert("本地流发布失败 " + error);
					})
					.then(() => {
						$("#local_stream").addClass("mainVedio").parent().addClass("active");
						console.log("本地流发布成功")
					})
			},
			// 远端监听
			updateStream() {
				var that = this;
				this.client.on("peer-leave", (event) => {
					console.log("远端关闭")
					that.hasLocal = false;
					// this.$message.error("报警人已挂断，请稍候");
					const userId = event.userId;
					let ind;
					ind = that.list.findIndex((v) => v.userId === userId);

					let obj = that.list[ind];
					let element = document.getElementById(obj.id);
					let parentNode = element.parentNode.parentNode;

					if (ind == 0) {
						let element = document.getElementById(obj.id);
						element.parentNode.parentNode.removeChild(element.parentNode);
					} else if (ind > 0) {
						let element = document.getElementById(obj.id);
						element.parentNode.parentNode.removeChild(element.parentNode);
					}

					if (parentNode.children.length == 2) {
						this.$message.error('已全部挂断');
						that.leaveRoom();
					}
					if (parentNode.children.length > 2) {
						this.$message.error('有人退出');
						this.myTempIndex = 0;
					}
					//8005
					that.list.splice(ind, 1);
					that.fullVideo = false;
				})
				this.client.on("stream-removed", (event) => {
					console.log('remove了')
					const remoteStream = event.stream;
				})
				// 关闭摄像头
				this.client.on("mute-video", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					if (streamId) {
						$("#mask_" + streamId).show();
					}
				})
				// 打开摄像头
				this.client.on("unmute-video", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					if (streamId) {
						$("#mask_" + streamId).hide();
					}
				})
				// 关闭语音
				this.client.on("mute-audio", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					$(`${"#user_" + streamId}`).find("#audio_" + streamId).hide().next().show();
				})
				// 打开语音
				this.client.on("unmute-audio", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					$(`${"#user_" + streamId}`).find("#unaudio_" + streamId).hide().prev().show();
				})
			},
			// 根据id获取uid
			getUidByStreamId(streamId) {
				for (let [uid, stream] of this.members_) {
					if (stream.getUserId() == streamId) {
						return uid;
					}
				}
			},
			// 订阅远端流--加入房间之前
			subscribeStream() {
				this.showPolice = true;
				let _this = this;
				this.client.on("stream-added", (event) => {
					const remoteStream = event.stream;
					this.isHave = false;
					for (let [uid, stream] of this.members_) {
						if (stream.getUserId() === remoteStream.getUserId()) {
							$("#user_" + stream.getId()).remove();
							this.members_.delete(stream.getId());
							this.isHave = true;
						}
					}
					remoteStream.isMute = true;
					remoteStream.muteMeVideo = () => {
						remoteStream.muteVideo();
					}
					remoteStream.getAdLevel = () => {
						return remoteStream.getAudioLevel();
					}
					remoteStream.stopVideo = () => {
						remoteStream.stop();
					}
					remoteStream.on('player-state-changed', event => {
						if (event.state === 'PAUSED') {

						}
					})
					remoteStream.snapRemoteImgMore = (remoteStreams, id) => {
						return new Promise((resolve, reject) => {
							_this.$nextTick(() => {
								const frame = remoteStreams.getVideoFrame();
								if (frame) {
									resolve(frame)
								} else {
									reject('无法获得截图数据')
								}
							})
						})
					}
					remoteStream.muteMeAudio = (id, phone) => {
						let res;
						let phoneKey = 'phone_' + phone;
						setTimeout(() => {
							if (!remoteStream.isMute) {
								let classMy = `#remote_stream-${id} .unMute`;
								$(classMy).attr("class", "mute");
								//8361
								res = remoteStream.muteAudio();
								_this.$message.info('该用户话筒已关闭，其他用户已听不到声音！');
								//8849
								_this.muteMeObj[phoneKey] = true;
							} else {
								let classMy = `#remote_stream-${id} .mute`;
								$(classMy).attr("class", "unMute");
								res = remoteStream.unmuteAudio();
								_this.muteMeObj[phoneKey] = false;
							}
						}, 0)
					}

					this.members_.set(remoteStream.getId(), remoteStream);
					// 订阅远端流
					this.client.subscribe(remoteStream);
				})
			},
			snapRemoteImg(videoUserId) {
				var _this = this;
				return new Promise((resolve, reject) => {
					let remoteStream;
					let id;
					let members = this.members_;
					let values = members.values();
					values = Array.from(values);
					let findMember = values.find(value => value.userId_ == videoUserId);
					remoteStream = findMember;
					id = findMember.id_;
					let stream = _this.list[0];
					_this.$nextTick(() => {
						const frame = remoteStream.getVideoFrame();
						if (frame) {
							resolve(frame);
						} else {
							reject("无法获得截图数据");
						}
					})
				})
			},
			snapRemoteImgMore(remoteStream, id) {
				let _this = this;
				return new Promise((resolve, reject) => {
					_this.$nextTick(() => {
						remoteStream.stop();
						remoteStream.play('remote_stream-' + id).then(() => {
							const frame = remoteStream.getVideoFrame();
							if (frame) {
								resolve(frame)
							} else {
								reject('无法获得截图数据')
							}
						})
					})
				})
			},
			muteMyVideo(id) {
				let stream = this.members_.get(id);
				stream.muteMeVideo();
			},
			muteMyAudio(id, phone) {
				let stream = this.members_.get(id);
				stream.isMute = !stream.isMute;
				this.members_.get(id, stream);
				stream.muteMeAudio(id, phone);
			},
			snapMyVideo(id) {
				let stream = this.members_.get(id);
				stream.snapRemoteImgMore(stream, id).then(data => {
					console.log('snap', data)
				})
			},
			stopMyVideo(id) {
				let stream = this.members_.get(id);
				// stream.stopVideo();
				this.client.unsubscribe(stream).catch(e => {
					console.error('failed to unsubscribe remoteStream')
				})
			},
			// 播放远端流
			playStream() {
				var that = this;
				this.client.on("stream-subscribed", async (event) => {
					this.videoBtnShow = false;
					const remoteStream = event.stream;
					let isMute = remoteStream.isMute;
					this.newStream = event.stream;
					// 创建远端流标签，因为id是动态的，所以动态创建，用了v-html
					const id = remoteStream.getId();
					const userId = remoteStream.getUserId();
					this.id = id;
					let myUsers = [];
					let findRes = myUsers.find(user => user.videoUserId == userId);
					let role;
					// let phone;
					let phone = this.userInfos.phone;
					if (findRes) {
						phone = findRes.phone || findRes.driverContact;
					}
					let phoneKey = 'phone_' + phone;
					if (that.muteMeObj[phoneKey] == true || that.muteMeObj[phoneKey] == false) {
						isMute = !that.muteMeObj[phoneKey];
						remoteStream.isMute = isMute;
						if (isMute) {
							remoteStream.unmuteAudio();
						} else {
							remoteStream.muteAudio();
						}
					}

					let findMyIndex = this.list.findIndex((v) => v.userId === remoteStream.getUserId())
					if (findMyIndex == -1) {
						console.log('走这里吧1')
						console.log('1', this.list)
						let length = this.list.length;
						length += 1;
						let name;
						if (userId && userId.indexOf('a') == 0) {
							name = '120人员';
						} else {
							name = '当事人';
						}
						this.remoteStream = `<div id="${'remote_stream-' + id}" style="width:100%;height:100%;position:relative;" onClick="goTop('${userId}','${id}')">
                                <span class="leftSide" onClick="muteMyAudio('${id}','${phone}');event.cancelBubble = true;">
                                    <span class="${isMute?'unMute':'mute'}" style="cursor:pointer" ></span>
                                    <span class="role">${name}</span>
                                </span>
                                <span class="stop" style="cursor:pointer;display:none;" onClick="kickPerson('${userId}');event.cancelBubble =true;"></span>
                                <span class="phone">${phone}</span>
                            </div>`;
						this.list.push({
							id,
							userId: remoteStream.getUserId(),
							remoteStream: this.remoteStream,
							origin: remoteStream,
						})
						if (this.list.length > 1) {
							$("#local_stream").removeClass('margin0');
						}
					} else {
						console.log('2', this.list)
						console.log('走这里吧2')
						let length = findMyIndex + 1;
						let name;
						if (userId && userId.indexOf('a') == 0) {
							name = '120人员';
						} else {
							name = '当事人';
						}
						this.remoteStream = `<div id="${'remote_stream-' + id}" style="width:100%;height:100%;position:relative;" onClick="goTop('${userId}','${id}')">
                                <span class="leftSide" onClick="muteMyAudio('${id}','${phone}');event.cancelBubble =true;">
                                    <span class="${isMute?'unMute':'mute'}" style="cursor:pointer" ></span>
                                    <span class="role">${name}</span>
                                </span>
                                <span class="stop" style="cursor:pointer;display:none;" onClick="kickPerson('${userId}');event.cancelBubble =true;"></span>
                                <span class="phone">${phone}</span>
                            </div>`;
						this.list.splice(
							findMyIndex,
							1, {
								id,
								userId: remoteStream.getUserId(),
								remoteStream: this.remoteStream,
								origin: remoteStream,
							}
						)
						if (this.list.length > 1) {
							$("#local_stream").removeClass('margin0');
						}
					}
					// 做了dom操作 需要使用$nextTick(),否则找不到创建的标签无法进行播放
					this.$nextTick(() => {
						console.log('有木有')
						// 播放
						remoteStream.play("remote_stream-" + id).then(() => {

						});
						let audio = $("#audio").clone();
						audio.attr("id", "audio_" + id);
						audio.css({
							width: "14px",
							height: "21px",
							background: "none",
							"margin-left": "auto",
						});
						let unaudio = $("#unaudio").clone();
						unaudio.attr("id", "unaudio_" + id);
						unaudio.css({
							width: "14px",
							height: "21px",
							background: "none",
							"margin-left": "auto",
						});

						let mask = $("#mask").clone();
						mask.text("");
						mask.attr("id", "mask_" + id);
						mask.css({
							width: "100%",
							height: "100%",
							"text-align": "center",
							"z-index": "99",
						});
						mask.appendTo($("#player_" + id));
						mask.hide();
						$("#player_" + id).css('background', "#eee")
						$("#player_" + id).css('box-sizing', "border-box");
						$("#player_" + id).css('padding', "2px");
						let status = $("<div>", {
							id: "status_" + id,
						});
						status.css({
							width: "100%",
							height: "100%",
							"text-align": "center",
							color: "#fff",
							display: "flex",
							"align-items": "center",
							"justify-content": "center",
						});
						status.html("<span>已离开会议<span>");
						status.appendTo($("#player_" + id));
						status.hide();
						$("#player_" + id).css({
							position: "absolute",
							top: "0px"
						});
					})
				})
			},
			async closeRoom() {
				if (!this.localStream) {
					return;
				}
				console.log("关闭本地")
				this.newStream = null;
				this.videoBtnShow = true;
				await this.client.unpublish(this.localStream);
				this.localStream.stop();
				this.localStream.close();
				this.localStream = null;
				this.fullVideo = false;
				await this.client.leave();
			},
			// 获取用户签名--前端测试用
			genTestUserSig(userID) {
				const SDKAPPID = config.sdkappid;
				const EXPIRETIME = 604800;
				const SECRETKEY = config.SECRETKEY;
				if (SDKAPPID === "" || SECRETKEY === "") {
					return false;
				}
				const generator = new LibGenerateTestUserSig(
					SDKAPPID,
					SECRETKEY,
					EXPIRETIME
				)
				const userSig = generator.genTestUserSig(userID);
				return {
					sdkAppId: SDKAPPID,
					userSig: userSig,
				}
			},
			// 关闭/打开摄像头
			async muteLocalVideo() {
				if (this.isVedio) {
					this.isVedio = false;
					// this.localStream.muteVideo();
					const videoTrack = this.localStream.getVideoTrack();
					if (videoTrack) {
						await this.localStream.removeTrack(videoTrack)
						// 停止采集，关闭摄像头
						videoTrack.stop();
					}
				} else {
					this.isVedio = true;
					// this.localStream.unmuteVideo();
					const videoStream = TRTC.createStream({
						userId: this.userId,
						audio: false,
						video: true
					})
					await videoStream.initialize();
					await this.localStream.addTrack(videoStream.getVideoTrack());
				}
			},
			// 关闭/打开麦克风
			async muteLocalAudio() {
				if (this.isAudio) {
					this.isAudio = false;
					this.localStream.muteAudio();
					this.$message.info('该用户话筒已关闭，其他用户已听不到声音！');
					// const audioTrack = this.localStream.getAudioTrack();
					// if (audioTrack) {
					//     audioTrack.stop();
					// }
				} else {
					this.isAudio = true;
					let res = this.localStream.unmuteAudio();
					console.log("unmuteAudio", res)
					// await this.localStream.replaceTrack(this.localStream.getAudioTrack());
				}
			},
			leaveRoom() {
				this.videoBtnShow = true;
				this.showPolice = false;
				this.remoteStatus == 'danger';
				this.list = [];
				this.muteMeObj = {};
				this.hasLocal = false;
				this.closeRoom();
			},

			// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-* 音视频相关操作 end *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*

		},
	}
</script>

<style lang="less" scoped>
	.main {
		display: flex;
		background: #fff;
		flex-direction: row;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		overflow-y: hidden;
		z-index: 100;
		flex-direction: column;
		box-sizing: border-box;
		padding-top: 3px;
		padding-left: 10px;
	}

	.leftContent {
		overflow-x: hidden;
		height: calc(100% - 50px);
		overflow-y: scroll;
		box-sizing: border-box;
		text-align: left;
		margin-right: 10px;
		float: left;

		.tableContent {
			margin-top: 10px;
			border: 1px solid #f4f5f7;
			flex: 3;
		}
	}

	.rightContent {
		width: 471px;
		// height: 100%;
		height: calc(100% - 90px);
		display: flex;
		position: fixed;
		top: 53px;
		right: 2px;
		float: right;

		.left {
			width: 100%;
			box-sizing: border-box;
			display: flex;
			overflow-y: auto;
			background: #eee;
			align-content: flex-start;
			margin-bottom: 10px;
			flex-wrap: nowrap;
			flex-direction: column;

			.userlist {
				width: 190px;
				height: 150px;
				border-radius: 1px;
				margin-top: 10px;
				position: static;
				display: flex;
				flex-direction: column;
				margin-top: auto;
				background-position: center 0px;
				background-size: 100%;
				position: relative;
				margin-left: 0px;

				&:nth-child(2n) {
					margin-left: 0px;
				}

				p {
					color: #fff;
					font-size: 14px;
					text-align: center;
				}

				.img {
					width: 100%;
					height: 130px;
					background: #fff;
				}
			}

			.remoteClass {
				width: 100%;
				height: 122px;
				margin-top: 0px !important;
				border: none !important;
			}

			.fullRemoteClass {
				width: 100% !important;
				margin-top: 25px;
				border: none !important;
			}
		}

		.right {
			width: calc(100vw - 210px);
			height: calc(100vh - 69px);
			background-color: #3d3b3b;
			border-radius: 1px;
			margin: 0 10px 10px 10px;
			padding: 0 10px;

			.container {
				width: 100%;
				height: 820px;
				background: #191f24;
			}

			.maskshow {
				display: block;
			}

			.operator {
				display: flex;
				justify-content: center;
				margin-top: 20px;
				text-align: center;
				position: absolute;
				bottom: 40px;
				left: 50%;

				.item {
					display: flex;
					flex-direction: column;
					width: 80px;

					&:nth-child(1) .img-warp .img {
						width: 23px;
					}

					&:nth-child(2) .img-warp .img {
						width: 40px;
					}

					&:nth-child(3) .img-warp {
						background: #e63517;

						.img {
							width: 44px;
						}
					}

					.img-warp {
						width: 100%;
						height: 45px;
						text-align: center;
						line-height: 45px;
						background: #e3e3e3;
						border-radius: 10px;
						position: relative;

						.img {
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
						}
					}

					&:not(:first-child) {
						margin-left: 20px;
					}

					.item-icon {
						width: 80px;
						height: 45px;
						line-height: 45px;
						background-color: #e3e3e3;
						border-radius: 10px;
					}

					span {
						font-size: 16px;
						text-align: center;
						color: #fff;
						margin-top: 10px;
					}
				}
			}
		}
	}

	.distant-stream {
		width: 100%;
		height: 100%;
	}

	#local_stream {
		width: 100%;
		height: 100%;
	}

	.mainVedio {
		position: absolute;
		z-index: 110;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding-left: 2px;
		padding-right: 2px;
		padding-bottom: 2px;
	}

	#warp {
		display: flex;
		flex-direction: column;
	}

	.maskable {
		position: absolute;
		width: calc(100% - 386px);
		right: 0px;
		height: 80%;
		color: #fff;
		text-align: center;
		line-height: 900px;
		background: url(../../../static/images/08摄像头已关闭@2x.png) center no-repeat;
	}

	.wholeAcccindentClass {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;

		.accidentImages {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-flow: wrap;

			.images {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-direction: column;
				height: 200px;
				margin: 10px;

				.img-box {
					width: 200px;
					margin: 0 auto;
				}
			}
		}
	}

	.bottomBtns {
		width: 100%;
		position: fixed;
		left: 0px;
		bottom: 0px;
		background: #ccc;
		margin-bottom: 0px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10;
	}

	.hang_up_btn {
		width: 40px;
		height: 40px;
		margin-left: 150px;
	}
	.hang_up_btn img {
		width: 100%;
		height: 100%;
	}

	.original_left {
		width: calc(100% - 473px);
	}

	.fullVideoClass_left {
		width: calc(100% - 610px) !important;
	}

	.fullVideoClass_right {
		max-width: 600px !important;
		min-width: 600px !important;
	}

	.myBtn {
		padding: 12px 16px !important;
		color: #000;
		cursor: pointer;

		img {
			width: 50px;
			height: 50px;
			margin-bottom: 10px
		}
	}

	.myMainVideo {
		width: 100% !important;
		height: 476px !important;
		margin: 0 auto !important;
		position: absolute !important;
		top: 2px;
		left: 50%;
		margin-left: -50% !important;
	}

	.myIcon {
		width: 28px;
		height: 28px;
		position: absolute;
		right: 3px;
		top: 3px;
		z-index: 99999;
		cursor: pointer;
	}

	.fullVideoClass_right {
		height: 88%;
		overflow: scroll;
	}

	.fullVideoClass_right .left .user,
	.fullVideoClass_right .left .police {
		height: 200px !important;
		width: 200px !important;
	}

	.fullVideoClass_right .myMainVideo {
		height: 600px !important;
	}

	.close_img {
		width: 14px;
		height: 14px;
		margin-left: 7px;
	}

	.jumpBtn {
		position: absolute;
		right: 476px;
		height: 30px;
		display: flex;

		.myJumpBtn {
			box-sizing: border-box;
			padding: 0px 5px;
			font-size: 12px;
			border: 1px solid #409eff;
			border-radius: 4px;
			margin-right: 10px;
			line-height: 28px;
			background: #409eff;
			color: #fff;
			cursor: pointer;
		}
	}

	.crumb {
		margin: 6px;

		.crumb_item {
			box-sizing: border-box;
			cursor: pointer;
			padding: 5px 10px !important;
		}
	}

	.activeCrumb {
		color: #1728d5;
		font-weight: bold;
	}

	.main /deep/ input::-webkit-outer-spin-button,
	.main /deep/ input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	// .main /deep/ input[type="number"] {
	//     -moz-appearance: textfield;
	// }

	.big_case {
		width: 96%;
		margin: 0 auto;
		display: flex;
		border-bottom: 1px solid #ededed
	}

	.ul_case {
		width: 80%;
		margin: 0px auto;
		padding: 10px;
	}

	.ul_case li {
		display: flex;
		margin: 5px 0;
	}

	.ul_contor {
		width: 10%;
		padding: 10px;
	}

	.ul_contor li {
		height: 30px;
		// margin: 10px 0;
		display: flex;
		// align-items: center;
		// justify-content: center;
	}

	.ul_contor li i {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 23px;
		color: #409EFF;
		cursor: pointer;
	}

	.big_case .ul_contor .ul_li_btn {
		width: 100px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		display: block;
		background: #409EFF;
		color: #fff;
		cursor: pointer;
	}

	.retrun_case {
		display: flex;
		flex-flow: wrap;
	}

	.retrun_image {
		width: calc((100% - 60px) / 6);
		min-height: 80px;
		max-height: 100px;
		margin: 10px 5px;
		display: block;
		object-fit: contain;
		cursor: pointer;
	}

	.rotate_image {
		transform: rotate(0deg);
	}

	.case_address {
		margin-left: 15px;
		display: flex;
		align-items: center;
	}

	.icon_address {
		width: 22px;
		height: 26px;
		display: inline-block;
		background: url("../../assets/images/pics/icon_adress.png") no-repeat center;
		background-size: 22px 26px;
		cursor: pointer;
	}

	.my_input /deep/ .el-textarea__inner {
		font-size: 16px;
		font-weight: bold;
		color: #000;
	}
	.situation .input_new_style /deep/ .el-date-editor .el-input__inner {
		width: inherit!important;
	}
	.note_btn {
		height: 50px;
		line-height: 50px;
		text-align: center;
	}
	.no_video_text {
		justify-content: center;
		align-items: center;
		font-size: 16px;
		font-weight: 600;
		color: #F56C6C;
	}
</style>


// WEBPACK FOOTER //
// video.vue?ae67d700